// src/services/api/apiMethods.js
import axios from "axios";
import { apiHandler } from "./apiWrapper";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5113/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token && !config.url.includes("/auth/login")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.log(error);

    const isUnauthorized = error.response && error.response.status === 401;
    const isNetworkError = !error.response; // no response from server

    if ((isUnauthorized || isNetworkError) && false) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

// API Methods
export const apiGet = (endpoint) =>
  apiHandler(
    () => api.get(endpoint),
    (res) => res
  );

export const apiGetById = (endpoint, id) =>
  apiHandler(
    () => api.get(`${endpoint}/${id}`),
    (res) => res
  );

export const apiPost = (endpoint, data) =>
  apiHandler(
    () => api.post(endpoint, data),
    (res) => res
  );

export const apiPut = (endpoint, data) =>
  apiHandler(
    () => api.put(endpoint, data),
    (res) => res
  );

export const apiDelete = (endpoint) =>
  apiHandler(
    () => api.delete(endpoint),
    (res) => res
  );

export const apiPostFormData = (endpoint, formData) =>
  apiHandler(
    () =>
      api.post(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    (res) => res
  );
